export default {
  title: 'Creează parolă nouă',
  description: 'Creați o parolă nouă pentru contul dvs.',
  form: {
    new_password: {
      label: 'Parolă nouă',
      placeholder: 'Introduceți parola',
      requirements: 'Parola trebuie să conțină 8 caractere, o literă mare și o cifră',
    },
    confirm_password: {
      label: 'Confirmare parolă nouă',
      placeholder: 'Confirmați parola',
    },
    error_messages: {
      missing_info: 'Informații lipsă',
    },
  },
  buttons: {
    update_password: 'Actualizați parola',
  },
};
